<template>
  <div>
    <b-row class="no-gutters">
      <b-col>
        <h1 class="font-weight-bold header-main text-uppercase mb-3">
          หมายเลขคำสั่งซื้อ :
          {{ orderDetail.invoiceNo ? orderDetail.invoiceNo : "-" }}
        </h1>
      </b-col>
      <b-col class="text-right d-flex justify-content-end">
        <b-button variant="link" class="px-1 py-0" @click="handleRoute">
          <u class="text-purple-btn">ย้อนกลับ</u>
        </b-button>
      </b-col>
    </b-row>

    <div class="mt-2">
      <div class="p-4 bg-white">
        <b-container class="p-0">
          <b-row>
            <b-col sm="8">
              <p class="mb-0 mr-4">
                <!-- <strong
                  ><span
                    >วัน / เวลา ที่ทำการสั่งซื้อ :ㅤ{{
                      new Date(orderDetail.createdTime) | moment($formatDate)
                    }}</span
                  >
                  <span class="text-gray"
                    >ㅤ({{
                      new Date(orderDetail.createdTime) | moment($formatTime)
                    }})</span
                  ></strong
                > -->
                 <strong>
                  <span>
                    วัน / เวลา ที่ทำการสั่งซื้อ :
                    {{
                      new Date(orderDetail.createdTime) | moment($formatDate)
                    }}
                  </span>
                  <span class="text-gray">
                    ({{
                      new Date(orderDetail.createdTime) | moment($formatTime)
                    }})
                  </span>
                </strong>
              </p>
            </b-col>
            <b-col sm="2" class="text-right d-flex justify-content-end">
              <p class="mb-0">
                <strong>สถานะคำสั่งซื้อ :</strong>
              </p>
            </b-col>
            <b-col sm="2" class="text-right d-flex justify-content-end">
              <p class="mb-0">
                {{ orderDetail.status }}
              </p>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="8">
              <p class="mb-0 mr-4">
                <strong>
                  <span>
                    ช่องทางการชำระเงิน :
                    {{ orderDetail.paymentTypeName }}
                  </span>
                </strong>
                <!-- <span
                  class="modal-link pointer text-purple-1 ml-2"
                  @click="openPaymentDetail"
                  v-if="orderDetail.invoiceNo"
                  >ดูหลักฐานการโอนเงิน</span
                > -->
              </p>
            </b-col>
            <b-col sm="2" class="text-right d-flex justify-content-end">
              <p class="mb-0">
                <strong>
                  ช่องทางการสั่งซื้อ :
                </strong>
              </p>
            </b-col>
            <b-col sm="2" class="text-right d-flex justify-content-end">
              <p class="mb-0">
                {{ orderDetail.sellerShopName || "-" }}
              </p>
            </b-col>
            <b-col sm="2" class="mt-2">
              <div>
                <div
                  v-if="orderDetail.imageUrl"
                  class="seller-image"
                  v-bind:style="{
                    'background-image': 'url(' + orderDetail.imageUrl + ')',
                  }"
                ></div>
                <div v-else class="">{{ orderDetail.salesChannel }}</div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-0">
            <b-col sm="8">
              <p class="mb-0 mr-4">
                <strong
                  ><span>หมายเลข Batch ID :ㅤ{{ orderDetail.batchNo }}</span>
                </strong>
              </p>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-row class="mt-3 header-detail">
        <b-col sm="4" class="pr-0">
          <div class="p-4 bg-white">
            <b-container class="p-0">
              <p>
                <b-row>
                  <b-col>
                    <strong>รายละเอียดผู้สั่งซื้อ</strong>
                  </b-col>
                  <b-col class="text-right d-flex justify-content-end">
                    <!-- <span class="modal-link-active text-purple-1">พิมพ์</span> -->
                    <!-- <span
                      :class="classEditTaxInvoice"
                      @click="openTaxInvoice('shipping')"
                      >เพิ่ม/แก้ไข</span
                    > -->
                  </b-col>
                </b-row>
              </p>
              <p class="mb-0">
                {{ orderAddressShow.firstname }} {{ orderAddressShow.lastname }}
              </p>
              <p>
                {{ orderAddressShow.address }} {{ orderAddressShow.province }}
                {{ orderAddressShow.district }}
                {{ orderAddressShow.subDistrict }}
                {{ orderAddressShow.zipCode }}
              </p>
            </b-container>
          </div>
        </b-col>
        <b-col sm="4" class="pr-0">
          <div class="p-4 bg-white">
            <b-container class="p-0">
              <p>
                <b-row>
                  <b-col>
                    <strong>ข้อมูลใบกำกับภาษี</strong>
                  </b-col>
                  <b-col class="text-right d-flex justify-content-end">
                    <!-- <span class="modal-link-active text-purple-1">พิมพ์</span> -->
                    <!-- <span
                      :class="classEditTaxInvoice"
                      @click="openTaxInvoice('billing')"
                      >เพิ่ม/แก้ไข</span
                    > -->
                  </b-col>
                </b-row>
              </p>
              <p class="mb-0">
                {{ orderTaxAddressShow.firstname }}
                {{ orderTaxAddressShow.lastname }}
              </p>
              <p class="mb-0">
                {{ orderTaxAddressShow.address }}
                {{ orderTaxAddressShow.province }}
                {{ orderTaxAddressShow.district }}
                {{ orderTaxAddressShow.subdistrict }}
                {{ orderTaxAddressShow.zipcode }}
              </p>
            </b-container>
          </div>
        </b-col>
        <b-col sm="4">
          <div class="p-4 bg-white">
            <b-container class="p-0">
              <b-row class="mb-1">
                <b-col>
                  <strong>รายละเอียดการจัดส่ง</strong>
                </b-col>
                <!-- <b-col>
                  <b-dropdown
                    id="dropdown-1"
                    class="btn-brand-selected small-dropdown print-selected"
                    right
                    no-flip
                    :disabled="
                      orderDetail.statusId == 3 ||
                        orderDetail.statusId == 9 ||
                        orderDetail.statusId == 13
                    "
                  >
                    <template v-slot:button-content>
                      <div class="d-flex">
                        <div class="my-auto">
                          <b-icon icon="printer"></b-icon> พิมพ์เอกสาร
                        </div>
                      </div>
                    </template>
                    <template v-for="print in printSelected">
                      <b-dropdown-item :key="print.id">
                        <div class="d-flex">
                          <div class="my-auto">
                            {{ print.text }}
                          </div>
                        </div>
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </b-col> -->
              </b-row>
              <p>
                <strong>ช่องทางการจัดส่ง :</strong>ㅤ{{
                  orderDetail.shippingName ? orderDetail.shippingName : "-"
                }}
              </p>
              <p>
                <strong>Tracking no. :</strong>ㅤ{{
                  orderDetail.trackingNo || "-"
                }}
              </p>
              <p>
                <strong>BOXME Tracking no. :</strong>ㅤ{{
                  orderDetail.shipjungTrackingNo || "-"
                }}
              </p>
              <!-- <p><strong>ป้ายทะเบียนจอดรถ :</strong>ㅤ-</p> -->
              <!-- <p>
                <span class="text-purple-btn">ลายเซ็นต์ขนส่ง</span>ㅤ<span
                  class="text-purple-btn"
                  >หลักฐานการจัดส่ง</span
                >
              </p> -->
            </b-container>
          </div>
        </b-col>
      </b-row>
      <OrderDetailPanel
        v-if="dataReady"
        :orderProductDetail="orderProductDetail"
        :orderProductPriceDetail="orderProductPriceDetail"
      />
      <DetailPanel v-if="dataReady" :details="orderStatusLog" />
      <Note
        v-if="dataReady"
        :id="id"
        :note="orderNoteLog"
        v-on:onSubmitNote="getOrderDetails"
      />
      <TaxInvoice
        ref="taxInvoiceModal"
        v-if="dataReady"
        :id="id"
        :shippingAddress="orderAddress"
        :billingAddress="orderTaxAddress"
        :nameTitleOption="nameTitleOption"
      />
      <ModalPaymentDetail
        ref="modalPaymentDetail"
        v-if="dataReady"
        :orderId="id"
        :invoiceNo="orderDetail.invoiceNo || ''"
        :orderTotalAmount="orderProductPriceDetail.grandTotal || 0"
        :isCanEdit="orderDetail.statusId == 3 || orderDetail.statusId == 9"
        v-on:onRefreshData="hadleModalAlertClose"
      />
    </div>
  </div>
</template>
<script>
import OrderSimple from "@/assets/mockdata/order/OrderSimple.json";
import OrderDetailPanel from "./components/order-detail/OrderDetailPanal.vue";
import DetailPanel from "./components/detail/DetailPanel.vue";
import Note from "./components/note/Note.vue";
import TaxInvoice from "./components/modal/TaxInvoice.vue";
import ModalPaymentDetail from "./components/modal/ModalPaymentDetail.vue";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import { BIcon } from "bootstrap-vue";
export default {
  name: "OrderDetails",
  components: {
    OrderSimple,
    OrderDetailPanel,
    DetailPanel,
    Note,
    TaxInvoice,
    ModalPaymentDetail,
    ModalAlertConfirm,
    BIcon,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
      dataReady: false,
      modalMessage: "",
      controlTab: isNaN(parseInt(this.$route.query.tab))
        ? 1
        : parseInt(this.$route.query.tab),
      state: {
        isLoading: false,
      },
      orderJson: OrderSimple,
      orderAddress: {},
      orderAddressShow: [],
      orderDetail: {},
      orderNoteLog: [],
      orderProductDetail: [],
      orderProductPriceDetail: {},
      orderStatusLog: [],
      orderTaxAddress: {},
      orderTaxAddressShow: [],
      nameTitleOption: [],
      printSelected: [
        {
          id: 0,
          text: "พิมพ์ใบปะหน้า",
          value: 1,
        },
        {
          id: 1,
          text: "พิมพ์ใบจัดเตรียมสินค้า",
          value: 2,
        },
      ],
      classEditTaxInvoice: "ml-3 modal-link-active",
      titleModal: "",
      detailModal: "",
      actionType: 0,
      productList: [],
    };
  },
  created() {
    this.getOrderDetails();
    this.getTitleName();
  },
  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    handleRoute() {
      if (this.hasHistory()) this.$router.back();
      else
        this.$router.push({
          path: `/order?brandID=${this.$route.query.brandID}`,
        });
    },
    getOrderDetails() {
      this.dataReady = false;
      this.axios
        .get(`${this.$baseUrl}/Batch/OrderDetail/${this.id}`)
        .then((data) => {
          let detail = data.detail;
          this.orderDetail = detail.dataDetail[0];
          this.orderNoteLog = detail.logOrderNote;
          this.orderProductDetail = detail.product;
          this.orderProductPriceDetail = detail.cost;
          this.orderAddressShow = detail.orderAddress[0];
          this.orderTaxAddressShow = detail.orderTaxAddress[0];
          this.orderStatusLog = detail.logWarehouseDetail;
          this.classEditTaxInvoice =
            this.orderDetail.statusId == 2 ||
            this.orderDetail.statusId == 3 ||
            this.orderDetail.statusId == 4
              ? "ml-3 modal-link-active"
              : "ml-3 modal-link-disabled";
          // this.dataReady = true; // ถ้าไม่ call this.getOrderAddress();
          this.getOrderAddress();
        });
    },
    getOrderAddress() {
      this.axios
        .get(`${this.$baseUrl}/Order/TNL/${this.id}/Address`)
        .then((data) => {
          if (data.result == 1) {
            this.orderAddress = data.detail.shippingAddress;
            this.orderTaxAddress = data.detail.billingAddress;
          }
          this.dataReady = true;
        });
    },
    getTitleName() {
      this.axios.get(`${this.$baseUrl}/Order/NameTitle`).then((data) => {
        if (data.result == 1) {
          this.nameTitleOption = data.detail;
        }
      });
    },
    openPaymentDetail() {
      this.$refs.modalPaymentDetail.show();
    },
    async openTaxInvoice(type) {
      await this.$refs["taxInvoiceModal"].openModal(type);
    },
    hadleModalAlertClose() {
      this.getOrderDetails();
    },
  },
  computed: {
    isDisabled() {
      return this.$route.params.id == 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-gray {
  color: #bcbcbc;
}
.print-selected {
  border-color: #6f67bf;
}
.header-detail {
  .bg-white {
    height: 220px;
  }
}
.modal-link-active {
  color: #b41bb4;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}
.modal-link-disabled {
  color: #bcbcbc;
  font-size: 14px;
  pointer-events: none;
}
.header-btn {
  font-size: 15px;
  margin-top: 12.5px;
  text-decoration: underline;
}
.text-purple-btn {
  color: #b41bb4;
  cursor: pointer;
  text-decoration: underline;
}
.text-purple-btn:hover {
  color: #7160c4;
}
.seller-image {
  height: 30px;
  width: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
</style>
